module.exports = __webpack_public_path__ + "img/icon-search.d41bf704.svg";